var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"base-switch",attrs:{"name":_vm.name,"switch":""},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}})}
var staticRenderFns = []

export { render, staticRenderFns }